import { useMutation, useQueryClient } from 'react-query';
import { registerForTheEvent } from 'src/common/services/event';
import { QueryKey } from 'src/config/queryKey';
import { useCurrentUserKeyEnhanceFactory } from 'src/common/hooks/useCurrentUserKeyEnhancer';

export interface RegisterForTheEventMutationProps {
  courseId: number;
  eventId: number;
}

export function useRegisterForTheEventMutator() {
  const queryClient = useQueryClient();
  const keyEnhancer = useCurrentUserKeyEnhanceFactory();

  return useMutation<unknown, unknown, RegisterForTheEventMutationProps>(
    ({ eventId }) => registerForTheEvent(eventId),
    {
      onSettled: (data, error, { courseId }) =>
        Promise.all([
          queryClient.invalidateQueries(keyEnhancer([QueryKey.CourseEvents, courseId]).key),
          queryClient.invalidateQueries(keyEnhancer([QueryKey.CurrentUserIncomingEvents]).key),
        ]).then(() => undefined),
    },
  );
}
